"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientProgressDetailScreen = void 0;
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const patient_overview_table_1 = __importStar(require("../../components/table/patient-overview-table"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const PatientProgressDetailScreen = ({ getPatientProgress, pendingPatientProgress, pendingUpdatePatientProgressSection, pendingUpdatePatientProgressContent, patientProgressAccount, patientProgress, user, match, updatePatientProgressSection, updatePatientProgressContent, isSectionAvailable, isContentAvailable, resetFilters }) => {
    const { accountId } = match.params;
    react_1.useEffect(() => {
        getPatientProgress({ id: accountId });
        return () => resetFilters();
    }, [user]);
    if (pendingPatientProgress)
        return react_1.default.createElement(components_1.ScreenLoader, null);
    const onCheck = (type, contentType, id, value) => {
        if (type === patient_overview_table_1.RowType.section) {
            updatePatientProgressSection({
                id: accountId,
                sectionId: id,
                state: value ? 'INCOMPLETE' : 'COMPLETE',
            });
        }
        else {
            updatePatientProgressContent({
                id: accountId,
                contentId: id,
                contentType,
                state: value ? 'INCOMPLETE' : 'COMPLETE',
            });
        }
    };
    return (react_1.default.createElement("div", { className: styles_scss_1.default.patientProgressDetail },
        react_1.default.createElement(components_1.Meta, { title: constants_1.default.patientProgress.detail.helmetTitle, removeViewport: true }),
        react_1.default.createElement(components_1.Paper, { className: styles_scss_1.default.contentPaper },
            react_1.default.createElement(components_1.Link, { to: constants_1.Routes.PatientProgress },
                react_1.default.createElement(components_1.Button, { className: styles_scss_1.default.goBackButton, variant: "transparent", title: constants_1.default.patientProgress.detail.backToList, ariaLabel: constants_1.default.patientProgress.detail.backToList, imgUrls: { default: constants_1.Images.arrowLeftGreen, selected: constants_1.Images.arrowLeftGreen } })),
            react_1.default.createElement("div", { className: styles_scss_1.default.headerCont },
                react_1.default.createElement("div", { className: styles_scss_1.default.headerLeftCont },
                    react_1.default.createElement("h2", null, patientProgressAccount === null || patientProgressAccount === void 0 ? void 0 : patientProgressAccount.fullName))),
            react_1.default.createElement("div", { className: styles_scss_1.default.tableCont },
                react_1.default.createElement(patient_overview_table_1.default, { data: patient_overview_table_1.getPatientOverviewTableData(patientProgress), columns: patient_overview_table_1.patientOverviewColumns, onCheck: onCheck, pending: pendingUpdatePatientProgressSection || pendingUpdatePatientProgressContent, isSectionAvailable: isSectionAvailable, isContentAvailable: isContentAvailable })))));
};
exports.PatientProgressDetailScreen = PatientProgressDetailScreen;
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
    pendingPatientProgress: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.getPatientProgress),
    patientProgress: selectors_1.default.user.getPatientProgress(state),
    pendingUpdatePatientProgressSection: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.updatePatientProgressSection),
    pendingUpdatePatientProgressContent: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.updatePatientProgressContent),
    isSectionAvailable: (sectionId) => selectors_1.default.user.isSectionAvailable(state, sectionId),
    isContentAvailable: (contentId) => selectors_1.default.user.isContentAvailable(state, contentId),
    patientProgressAccount: selectors_1.default.user.getPatientProgressAccount(state)
});
const mapDispatchToProps = {
    getPatientProgress: (data) => radio_dispatch_1.reduxSet.makeLatestRequest.dispatch(api_payloads_1.getPatientProgressPayload(data)),
    resetFilters: () => redux_1.ActionCreators.user.resetFilters.dispatch(),
    updatePatientProgressSection: (data) => redux_1.ActionCreators.user.updatePatientProgressSectionRequest.dispatch(data),
    updatePatientProgressContent: (data) => redux_1.ActionCreators.user.updatePatientProgressContentRequest.dispatch(data),
};
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.PatientProgressDetailScreen));
